import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { privateRoutes } from "constant/route/privateRoutes";
import { useAuth } from "hooks‬/Auth";

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { fetchSubcriptionDetail, companyDetailFormDashboarding } = useAuth();

  useEffect(() => {
    fetchSubcriptionDetail();
    companyDetailFormDashboarding();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(privateRoutes.dashboard);
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center p-4">
      <FaCheckCircle size={120} color="green" className="mb-4" />
      <h1 className="text-success mb-3">Payment Successful!</h1>
      <p className="text-muted fs-3 mb-4">
        Thank you for your payment. You will be redirected to the dashboard
        shortly.
      </p>
      <button
        className="btn btn-success d-flex align-items-center"
        onClick={() => navigate(privateRoutes.dashboard)}
      >
        <FaCheckCircle className="me-2" />
        Go to Dashboard
      </button>
    </div>
  );
};

export default PaymentSuccess;
